import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import { useEffect } from "react"
import Spinner from "./Spinner"
import cn from "../../../utils/classes"
import { SemanticHeader } from "./SemanticHeader"
import Typography, { typographyTypes } from "./Typography"
import Button from "./Button"
import Card from "./Card"

export interface DocusignErrorArgs {
  message?: string
  onClick: () => void
}

interface DocusignPollerProps {
  error?: DocusignErrorArgs
  containerStyleOverrides?: string
}

export const DocusignPoller = ({
  error,
  containerStyleOverrides,
}: DocusignPollerProps) => {
  const { cms: cmsContent } = useCMSReady(["common"])
  const common = cmsContent.common

  const containerStyles = cn("m-16", containerStyleOverrides)

  useEffect(() => {
    if (!!error) {
      console.error(
        "DocusignPoller -- error fetching file after docusign redirect.",
        error.message,
      )
    }
  }, [error])

  const contentComponent = error ? (
    <div className="flex flex-col h-[179px] w-fit">
      <SemanticHeader
        text={common?.generalErrorMessageHeader || ""}
        headerLevel="h2"
        type="headerTitle"
        styleOverrides="font-medium"
      />
      <Typography
        variant={typographyTypes.NORMAL}
        styleOverrides="font-normal text-base"
        text={common?.docusignErrorText || ""}
      />
      <Button
        buttonLabel={common?.generalErrorMessageButtonText}
        roundedFull={false}
        onClick={error.onClick}
        styleOverrides="mt-6"
      />
    </div>
  ) : (
    <Spinner
      text={common?.docusignPollText}
      containerStyleOverrides="h-[100px] w-[100px]"
      parentStyleOverrides="h-[179px] w-fit"
      textStyleOverrides="text-[20px]"
    />
  )

  return (
    <div className={containerStyles}>
      <Card
        rounded
        styleOverrides="flex w-full items-center justify-center !px-[112px] !py-[76px] !shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_0px_rgba(0,0,0,0.05)] rounded-lg border-solid border-[1px] !border-[#E5E7EB]"
      >
        {contentComponent}
      </Card>
    </div>
  )
}
